export default {
    CONTACT_SEARCH: 'CONTACT_SEARCH',
    CONTRACT_PARTNER: 'CONTRACT_PARTNER',
    LOADER: 'LOADER',
    BC_ACTION_FAILED: 'BC_ACTION_FAILED',
};
